module.exports = __webpack_public_path__ + "ce2b5b26.svg";